
/**
 * Home 3 Sale Banner
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class HomeSaleBanner extends Component {

   render() {
    return (
        <div className="col-sm-12">
            <div className="magasin_banner_wrapper">
                <div className="magasin_banner magasin_banner-style-style-1 magasin_banner-effect-none ciya-banner-3">
                    <img className="magasin_banner-image img-fluid inline" alt="Banner" src={require(`../../assets/images/categories/modern/sub-banner.jpg`)}  />
                <div className="magasin_banner-content p-4 p-sm-5 magasin_banner-content-hleft magasin_banner-content-vmiddle ">
                    <div className="magasin_banner-content-wrapper">
                    <div className="magasin_banner-content-inner-wrapper">
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-1 magasin_banner-text-bg_color hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text tag-text"> only 24 hours</div>
                        </div>
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-2 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text"> Up To 50% Off</div>
                        </div>
                        <div className="magasin_banner-text-wrap magasin_banner-text-wrap-3 hidden-lg hidden-md hidden-sm hidden-xs">
                        <div className="magasin_banner-text"> Final Sale Items</div>
                        </div>
                        <div className="magasin_banner-btn-wrap magasin_banner-btn-style-link magasin_banner-btn-shape-square">
                        <Link to="/shop" className="magasin_banner-btn inline_hover">Shop now</Link></div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
      )
}
}

export default HomeSaleBanner;

